<template lang="pug">
    div
        Modal(
            title="Register your edges"
            v-model="isModalShow"
            width="800"
            @on-ok="createEdge"
            @on-visible-change="handleOnVisibleChange"
        )
            Form(:model="cloudForm" :rules="cloudFormValidate" ref="cloudForm")
                FormItem(label="Machine Hostname" prop="hostname")
                    Input(v-model="cloudForm.hostname" placeholder="aws-edge01" style="width: 180px" size="small")

            p Select your platform
            Row
                Col(span="12")
                    Card(:class="cardPointerClass(cloudForm.selectedPlatform == 'aws')" v-on:click.native="cloudForm.selectedPlatform = 'aws'")
                        img(src="/static/img/powered-by-aws.png" alt="Powered by AWS Cloud Computing")
                        div(v-show="cloudForm.selectedPlatform == 'aws'")
                            Form(:model="awsNodeConfig")
                                FormItem(label="Instance Type")
                                    RadioGroup(v-model="awsNodeConfig.instanceType")
                                        // Radio(label="t3.small")
                                        Radio(label="t3.medium")
                                            span t3.medium 2c/4g
                                FormItem(label="Region")
                                    RadioGroup(v-model="awsNodeConfig.region")
                                        Radio(label="ap-southeast-1")
                Col(span="12")
                    Card(:class="cardPointerClass(cloudForm.selectedPlatform == 'custom')" v-on:click.native="cloudForm.selectedPlatform = 'custom'")
                        h2 Custom
                        div(v-show="cloudForm.selectedPlatform == 'custom'")
                            p You can also register your own edge with your machine
                            p One-liner setup (Install docker + our images)
                            code 
                                mark bash <(curl -s http://www.example.com/setup.sh)
                            p Or
                            p Just download our <a href="#">docker-compose.yml</a> if you already have docker installed
            div(slot="footer")
                Button(@click="createEdge" v-show="cloudForm.selectedPlatform !== 'custom'") {{$t('global.create')}}


        Button(type="primary" icon="md-create" @click="isModalShow = true" :disabled="isCreateBtnDisabled") {{$t('global.create')}}

</template>
<script>
import { createEc2Edge } from "@/api/3rd/aws.js";
import { checkDocumentExist } from "@/api/documentexist";

export default {
    name: "CreateEdgeBtn",
    props: { isCreateBtnDisabled: { default: false } },
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            isModalShow: false,
            cloudForm: { hostname: "", selectedPlatform: "aws" },
            awsNodeConfig: { instanceType: "t3.medium", region: "ap-southeast-1", hostname: "" },
            cloudFormValidate: {
                hostname: [
                    {
                        required: true,
                        message: `${this.$t("edgesetting.hostname")} ${this.$t("rcmtable.validateEmptyText")}`,
                        trigger: "blur"
                    },
                    {
                        validator: (rule, value, callback, source, options) => {
                            if (!/^[a-z0-9\-\_]*$/.test(value))
                                return callback(
                                    new Error(`${this.$t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`)
                                );
                            if (value.length > 35)
                                return callback(new Error(`${this.$t("rcmtable.validateExceedLengthPrefix")}: 35`));
                            checkDocumentExist({
                                topic: "edgeHostname",
                                fieldVal: value
                            }).then(result => {
                                if (!result.data.success) {
                                    return callback(new Error(`${value} ${this.$t("rcmtable.validateExistText")}`));
                                }
                                callback();
                            });
                        },
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        createEdge() {
            if (this.cloudForm.selectedPlatform == "custom") return (this.isModalShow = false);
            this.$refs.cloudForm.validate(valid => {
                console.log(valid);
                if (!valid) return this.$Message.error(this.$t("rcmtable.formErrorMsg"));
                if (this.cloudForm.selectedPlatform == "aws") {
                    this.awsNodeConfig.hostname = this.cloudForm.hostname;
                    createEc2Edge(this.awsNodeConfig).then(res => {
                        console.log(res);
                        this.isModalShow = false;
                    });
                }
            });
        },
        handleOnVisibleChange(visible) {
            if (!visible) {
                console.log("HANDLE CLOSE");
                this.$refs.cloudForm.resetFields();
                this.isModalShow = false;
            }
        },
        cardPointerClass(isActive) {
            return isActive ? "cardPointer cardPointer-active" : "cardPointer";
        }
    },
    mounted() {},
    computed: {}
};
</script>
<style lang="less">
.cardPointer {
    transform: scale(0.98);
    cursor: pointer;
    margin: 6px 6px 0px 6px;
    background: #fff;
    color: black;
}

.cardPointer-active {
    box-shadow: 5px 5px 10px 5px #dedfe0;
}
</style>



// WEBPACK FOOTER //
// src/components/EdgeSetting/CreateEdgeBtn.vue